import React from 'react';
import { withTheme } from 'styled-components';

const SaveIcon = ({ width, height, theme, color }) => {
  return (
    <svg 
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill={ color ? theme.themeColors.controlBar.rightPanel.icons.searchIcon.color : '#ff0000' }
      xmlns="http://www.w3.org/2000/svg" 
      data-ignore-click-outside="sidebar"
    >
      <path d="M23.464 3.205h-20.259v25.59h25.59v-20.259l-5.331-5.331zM21.331 4.271v7.464h-10.662v-7.464h10.662zM27.729 27.729h-23.457v-23.457h5.331v8.53h12.795v-8.53h0.625l4.706 4.707v18.751z"></path>
      <path d="M18.153 6.404h1.066v3.199h-1.066v-3.199z"></path>
      <path d="M10.669 20.265h10.662v1.066h-10.662v-1.066z"></path>
      <path d="M10.669 23.464h10.662v1.066h-10.662v-1.066z"></path>
    </svg>
  );
};

export default withTheme(SaveIcon);
